export default function useAuthorizePaymentMutation(payload) {
    const {
        transactionId,
        correlationId,
        onSuccessCallback,
        onErrorCallback
    } = payload

    const headers = {
        'x-correlation-id': correlationId,
    }

    const apiUrl = `/api/payment/transactions/${transactionId}/prepare/`
    const mutationKey = ['authorize', transactionId]

    return useTanstackMutation({
        mutationKey,
        apiUrl,
        headers,
        method: 'POST',
        onSuccessCallback,
        onErrorCallback
    })
}
